// extracted by mini-css-extract-plugin
export default {"searchInput":"FilesCollectionControlBar_searchInput__Dx9iO"};